module.exports = __webpack_public_path__ + "static/media/lowDisabled.efb4b4bf.svg";